import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useReportStore from "../store/reportStore";

// Map routes to their corresponding page titles
const titleMap = {
  "/": "Elavon Data Platform",
  "/home": "Home | Elavon Data Platform",
};

/**
 * Custom hook to dynamically update the document title based on the current route
 * Place this hook in layout components that wrap your routes
 */
const useDocumentTitle = () => {
  const { pathname } = useLocation();
  const reportName = useReportStore((state) => state.reportName);

  useEffect(() => {
    if (pathname === "/dashboard") {
      if (reportName.includes("Authorization")) {
        document.title = `${reportName} | Elavon Data Platform`;
      } else if (
        reportName.includes("Dispute") ||
        reportName.includes("Chargeback") ||
        reportName.includes("Disputes Optimization Data Service") ||
        reportName.includes("Charge Back")
      ) {
        document.title = `${reportName} | Elavon Data Platform`;
      } else if (
        reportName.includes("Interchange & Downgrade Insights Data Service") ||
        reportName.toLowerCase().includes("icnd") ||
        reportName.toLowerCase().includes("interchange & downgrade insights") ||
        reportName.toLowerCase().includes("interchange") ||
        reportName.toLowerCase().includes("downgrade")
      ) {
        document.title = `${reportName} | Elavon Data Platform`;
      }
      return;
    }

    // Get title from map, fallback to default title if route not found
    const title = titleMap[pathname] || "Elavon Data Platform";
    document.title = title;
  }, [pathname, reportName]);
};

export default useDocumentTitle;
